// Copyright (c) 2026 by Audere

import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
} from "./commonV2";

export const cloverLabelingTypes = commonLabelingTypes;

const cloverLabelingTasks = commonLabelingTasks;

const cloverQuestions = commonQuestions;

export const cloverLabelingSchemaV2 = {
  labelingTypes: cloverLabelingTypes,
  labelingTasks: cloverLabelingTasks,
  labelingQuestions: cloverQuestions,
  labelingSchemaVersion: "cloverLabelingSchemaV2",
};
